export class DetailPromotionRequest {
  constructor(public readonly promotionKey: string,
              public readonly status: string,
              public readonly page: string,
              public readonly pageSize: string,
              public readonly username?: string) {
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/promociones/quantum/detail-promotion/detail-promotion-request.ts